import { render, staticRenderFns } from "./CgUiManage.vue?vue&type=template&id=ea1803a8&"
import script from "./CgUiManage.vue?vue&type=script&lang=js&"
export * from "./CgUiManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports